import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60bf11e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component nav" }
const _hoisted_2 = { class: "nav-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_UserInfo = _resolveComponent("UserInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Logo),
      _createVNode(_component_Menu),
      _createVNode(_component_UserInfo)
    ])
  ]))
}